import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'vrm-driver-import-grid-header',
  templateUrl: './driver-import-grid-header.component.html',
  styleUrls: ['./driver-import-grid-header.component.scss'],
})
export class DriverImportGridHeaderComponent implements IHeaderAngularComp {
  public params!: IHeaderParams;
  public displayName!: string;

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.displayName = this.params.displayName || '';
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return true;
  }
}
